'use client'

import { createContext, useState } from 'react'

export const ChatContext = createContext('')

export const ChatProvider = ({ children }) => {
  const [matches, setMatches] = useState([])
  const [currentMatch, setCurrentMatch] = useState(null)
  // uid whose /api/get_chats result currently backs `matches`. Lets /chat treat
  // a revisit as a background revalidate instead of blanking the page with the
  // loader; null means the cache is absent or holds guest/offline matches.
  const [matchesFetchedForUid, setMatchesFetchedForUid] = useState(null)

  return (
    <ChatContext.Provider
      value={{
        matches,
        setMatches,
        currentMatch,
        setCurrentMatch,
        matchesFetchedForUid,
        setMatchesFetchedForUid,
      }}
    >
      {children}
    </ChatContext.Provider>
  )
}
